<template>
  <div class="Consultation_mail">
    <el-row :gutter="0" class="Consultation_mail_content">
      <el-col :span="6" style="height: 100%">
        <div class="grid-content">
          <h2><img src="../../assets/consult/userList.png" alt="">{{this.RoleID.search("1058") != -1?"咨询师列表":"来访者列表"}}</h2>

          <div v-for="(item, itemIndex) in consultant" :key="itemIndex" :class="selCounselor==item.Counselor?'userInfo userInfoSel':'userInfo'" @click="getMessage(item)">
            <img v-if="item.HeadImg == null || item.HeadImg == ''" src="../../assets/consult/head.png" :alt="item.Name">
            <img v-else-if="item.HeadImg != null || item.HeadImg == ''" :src="item.HeadImg" :alt="item.Name">
            <div class="userContent">
              <div><name>{{item.Name}}</name><time>{{item.LastTime}}</time></div>
              <div v-if="item.MsgState == 0" class="isread"><read></read></div>
              <p>{{item.Content}}</p>
            </div>
          </div>
<!--          <div class="userInfo" onselect="true">-->
<!--            <img src="../../assets/consult/head.png" alt="">-->
<!--            <div class="userContent">-->
<!--              <div><name>诸葛亮</name><time>2023-05-16 15:12:00</time></div>-->
<!--              <p>这里显示最新的消息显示不下就是省略这里显示最新的消息显示不下就是省略这里显示最新的消息显示不下就是省略这里显示最新的消息显示不下就是省略</p>-->
<!--            </div>-->
<!--          </div>-->
        </div>
      </el-col>

      <el-col :span="12" style="height: 100%">
        <div class="grid-content center-message">
          <div class="allMessage" ref="mianscroll">
            <div v-for="(item, itemIndex) in currentMessage" :key="itemIndex">
              <other-message v-if="item.SendID != myUserID">
                <img v-if="item.SenderHeadImg == null || item.SenderHeadImg == ''" src="../../assets/consult/head.png" :alt="item.SenderName">
                <img v-else-if="item.SenderHeadImg != null || item.SenderHeadImg == ''" :src="item.SenderHeadImg" :alt="item.SenderName">
                <p>{{item.Message}}</p>
              </other-message>
              <my-message v-else-if="item.SendID == myUserID">
                <p>{{item.Message}}</p>
                <img v-if="item.SenderHeadImg == null || item.SenderHeadImg == ''" src="../../assets/consult/head.png" :alt="item.SenderName">
                <img v-else-if="item.SenderHeadImg != null || item.SenderHeadImg == ''" :src="item.SenderHeadImg" :alt="item.SenderName">
              </my-message>
            </div>


<!--            <other-message>-->
<!--              <img src="../../assets/consult/head.png" alt="">-->
<!--              <p>其他人发的信息其他人发的信息其他人发的信息其他人发的信息其他人发的信息其他人发的信息其他人发的信息。其他人发的信息其他人发的信息其他人发的信息其他人发的信息其他人发的信息其他人发的信息其他人发的信息。其他人发的信息其他人发的信息其他人发的信息其他人发的信息其他人发的信息其他人发的信息其他人发的信息。</p>-->
<!--            </other-message>-->
<!--            <my-message>-->
<!--              <p>其他人发的信。其他人发的信。其他人发的信。其他人发的信。其他人发的信。其他人发的信。其他人发的信。</p>-->
<!--              <img src="../../assets/consult/head.png" alt="">-->
<!--            </my-message>-->
          </div>
          <div class="submitMessage">
            <el-input
                    maxlength="400"
                    v-model="Content"
                    type="textarea"
                    :rows="4"
                    placeholder="不能自定义内容发送，请点击右侧的站内信模板发送！"
                     disabled>
            </el-input>
            <el-button style="margin-left: 15px" type="primary" @click="pushMessage" disabled>发送</el-button>
          </div>
        </div>
      </el-col>

      <el-col :span="6" style="height: 100%">
        <div class="grid-content">
          <h2><img src="../../assets/consult/template.png" alt="">站内信模板</h2>
          <common v-for="item in value36" @click="pushTemplate(item.cDicValue)">{{item.cDicValue}}</common>
        </div>
      </el-col>

    </el-row>
  </div>
</template>
<script>
export default {
  data() {
    return {
      RoleID:sessionStorage.getItem('RoleID'),
      myUserID: this.Global.userID,
      inputMessage:'',
      consultant:[],
      selCounselor:'',
      currentMessage:[],
      Content:'',
      // refresh:true,
      value36:[],
    };
  },
  mounted() {
    this.$Http_Post('User/GetDictionaryList', { DicTypCode: this.RoleID.search("1058") != -1?36:40 }).then((res) => {
      if (res.Code == 0) {
        this.value36 = res.Data;
      }
    });
    this.getConsultant(0);
    // window.setInterval(() => {
    //   setTimeout(this.getConsultant(0), 0)
    // }, 30000)

  },
  methods: {
    getConsultant(source){
      this.$Http_Post('ConsultAppoint/GetChatMessage', {
        UserID : this.Global.userID
      }).then((res) => {
        if (res.Code == 0) {
          this.consultant = res.Data;
          if(source == 0){
            this.selCounselor = res.Data[0].Counselor;
            this.getMessageList();
          }
        }
      });
    },
    getMessage(item){
      this.selCounselor = item.Counselor;
      this.getMessageList();
    },
    getMessageList(){
      this.$Http_Post('ConsultAppoint/GetChatMessage', {
        UserID : this.Global.userID,
        SenderID: this.selCounselor,
      }).then((res) => {
        if (res.Code == 0) {
          this.currentMessage = res.Data;
          let scrollEl = this.$refs.mianscroll;
          setTimeout(()=> {
            scrollEl.scrollTo({ top: scrollEl.scrollHeight, behavior: 'smooth' });
            console.warn(scrollEl.scrollHeight)
          }, 100);

        }
      });
    },
    pushMessage(){
      // this.refresh = false;
      // debugger;
      if(this.Content.trim()==""){
        this.Global.request_failure("发送内容不能为空！");
      }else if (this.selCounselor.trim()==""){
        this.Global.request_failure("请选择需要发送信息的咨询师！");
      }else {
        this.$Http_Post('User/SendSiteMessage', {
          UserID : this.selCounselor,
          Content: this.Content,
        }).then((res) => {
          if (res.Code == 0) {
            // this.Global.request_successful(res.Message);
            this.getMessageList();
            this.getConsultant(1);
            // this.refresh = true;
            this.Content = "";
          }else {
            this.Global.request_failure(res.Message);
          }
        });
      }
    },
    pushTemplate(template){
      this.Content = template;
      this.pushMessage();
    }
  },
};
</script>
<style>
.Consultation_mail{
  width: 100%;
  background-color: rgba(242, 242, 242, 1);
  padding-bottom: 15px;
  min-width:1180px;
  height: 100%;
}
.Consultation_mail_content {
  height: 100%;
}

.Consultation_mail_content .grid-content{
  background-color: #fff;
  height: 100%;
  border-radius: 2px;
}

.Consultation_mail_content .grid-content h2{
  display: flex;
  font-size: 18px;
  font-weight: 600;
  font-family: 微软雅黑;
  vertical-align: center;
  padding: 15px;
  border-bottom: 1px solid rgba(225, 226, 227, 1);
  margin-bottom: 10px ;
}
.Consultation_mail_content .grid-content h2 img{
  margin-right: 10px;
}
.Consultation_mail_content .grid-content .userInfo{
  display: flex;
  flex-direction: row;
  margin-left: 10px;
  padding: 10px;
  padding-left: 0px;
  border-bottom: 1px solid rgba(240, 240, 241, 1);
  border-radius: 10px 0px 0px 10px;
  cursor: pointer;
}
.Consultation_mail_content .grid-content .userInfo:hover{
  background-color: rgba(243, 250, 250, 1);
}
.Consultation_mail_content .grid-content .userInfoSel {
  background-color: rgba(233, 240, 247, 1);
}
.Consultation_mail_content .grid-content .userInfo img{
  width: 55px;
  height: 55px;
  border-radius:50% ;
  margin-right: 10px;
  margin-left: 10px;
}
.Consultation_mail_content .grid-content .userInfo .userContent{
  width: calc(100% - 60px);
  display: flex;
  flex-direction: column;
}
.Consultation_mail_content .grid-content .userInfo .userContent div{
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  padding-bottom: 10px;
}
.Consultation_mail_content .grid-content .userInfo .userContent .isread{
  display: flex;
  flex-direction: row-reverse;
  padding-bottom: 0px;
}
.Consultation_mail_content .grid-content .userInfo .userContent .isread read{
  display: block;
  border-radius: 50%;
  height: 6px;
  width: 6px;
  background-color: #00a2d4;
}
.Consultation_mail_content .grid-content .userInfo .userContent div name{
  font-size: 16px;
  font-weight: 600;
  word-wrap: break-word;
  min-width: 55px;
  /*超过一行显示省略号*/
  -webkit-line-clamp: 1;
  display: -webkit-box;
  -webkit-box-orient: vertical;
  overflow: hidden;
}
.Consultation_mail_content .grid-content .userInfo .userContent div time{
  color: #999;
  word-wrap: break-word;
  min-width: 140px;
  /*超过一行显示省略号*/
  -webkit-line-clamp: 1;
  display: -webkit-box;
  -webkit-box-orient: vertical;
  overflow: hidden;
}
.Consultation_mail_content .grid-content .userInfo .userContent p{
  color: #666;
  /*超过一行显示省略号*/
  -webkit-line-clamp: 1;
  display: -webkit-box;
  -webkit-box-orient: vertical;
  overflow: hidden;
  text-overflow: ellipsis;
  word-wrap: break-word;
}
.Consultation_mail_content .grid-content common{
  color: #666;
  width: 90%;
  margin-left: 5%;
  padding: 10px 0px;
  border-bottom: 1px solid rgba(240, 240, 241, 1);
  display: block;
  cursor: pointer;
}
.Consultation_mail_content .center-message{
  padding-top: 10px;
  height: calc(100% - 10px);
  background-color: rgba(233, 240, 247, 1)
}
.Consultation_mail_content .center-message other-message{
  display: flex;
  flex-direction: row;
  justify-content: flex-start;
  padding: 15px;
}
.Consultation_mail_content .center-message my-message{
  display: flex;
  flex-direction: row;
  justify-content: flex-end;
  padding: 15px;
}
.Consultation_mail_content .center-message img{
  width: 40px;
  height: 40px;
  border-radius:15% ;
}

.Consultation_mail_content .center-message other-message p{
  color: #fff;
  background-color: rgba(0, 136, 255, 1);
  max-width: 65%;
  min-width: 5%;
  border-radius: 0px 10px 10px 10px;
  margin-left: 10px;
  padding: 8px;
  word-wrap: break-word;
}
.Consultation_mail_content .center-message my-message p{
  background-color: #fff;
  max-width: 65%;
  min-width: 5%;
  border-radius: 10px 0px 10px 10px;
  margin-right: 10px;
  padding: 8px;
  word-wrap: break-word;
}
.Consultation_mail_content .center-message .allMessage{
  height: 85%;
  overflow:auto;
}
.Consultation_mail_content .center-message .submitMessage{
  display: flex;
  flex-direction: row;
  align-items: flex-end;
  height: 11%;
  padding: 15px;
}

</style>
